import {api} from "./api";
import {MODERATOR_TEST_QUESTION} from "../mock/URLs";
import {GetQuestionByIdResponse, GetTestQuestionResponse} from "../types/test";

type GetTestQuestion = {
  params: {
    test: number
  }
}

export const getTestQuestions = async ({params}: GetTestQuestion) => {
  try {
    const {data} = await api.get<GetTestQuestionResponse>(MODERATOR_TEST_QUESTION, {
      params
    })
    return data;
  } catch (e) {
    throw e
  }
}


// create test question uchun
type Answer = {
  answer_uz: string;
  answer_ru: string;
  answer_en: string;
  type: "RADIO" | "CHECKBOX"
  ball: number;
  is_correct: boolean;
};

export type IQuestionItem = {
  test: string;
  question_uz: string;
  question_ru: string;
  question_en: string;
  is_active: boolean;
  answers: Answer[];
};
export const createTestQuestion = async (formData: IQuestionItem[]) => {
  try {
    const {data} = await api.post(MODERATOR_TEST_QUESTION, formData)
    return data;
  } catch (e) {
    throw e
  }
}

//get question by id
export const getQuestionById = async (id: number) => {
  try {
    const {data} = await api.get<{ data: GetQuestionByIdResponse }>(`${MODERATOR_TEST_QUESTION}${id}/`)
    return data.data
  } catch (e) {
    throw e
  }
}


export const updateTestQuestion = async (id: number, values) => {
  try {
    const {data} = await api.patch(`${MODERATOR_TEST_QUESTION}${id}/`, values)
    return data;
  } catch (e) {
    throw e
  }
}